'use strict';
import {
  queryByFirstLastName,
  queryRrogatById,
  queryPlateById,
  queryCelById,
  queryGjcById,
  queryGjcByFamilyId,
  queryBottom100Names,
  queryByPlateId,
  queryNameCount,
  queryTop100NamesByYear,
  queryByCellNr,
  querySurameCount,
  queryTop100SurnamesEver,
  setCognitoJwtToken,
} from './data-source-module.js';
import { isOdd } from './utils-module.js';
import {
  gjcDivCardElement,
  gjcDivCardHeader,
  cardViewContainer,
  closeModal,
  openRrogatModal,
  showModalSearchByName,
  showModalSearchInputOne,
  showModalError,
} from './htmlSnipetBuilder.js';

import {
  cognitoSignIn,
  cognitoSignOut,
  getInitializedToken,
  getCurrentToken,
  storeJwtToken,
} from './aws-amplify-cognito.js';

/////////////////////////////////////////////////
// Elements
const labelWelcome = document.querySelector('.welcome');
const containerApp = document.querySelector('.app');
const containerMovements = document.querySelector('.movements');
const btnLogin = document.querySelector('.login__btn');
const formLogin = document.querySelector('.gjc-login-form');
const inputLoginUsername = document.querySelector('.login__input--user');
const inputLoginPassword = document.querySelector('.login__input--pin');
const signOut = document.querySelector('.gjc-signout');
//Menu List Items:
const menuToggle = document.getElementById('menuToggle');
const menuSearchByName = document.getElementById('search-by-name');
const menuSearchById = document.getElementById('search-by-id');
const menuSearchByFamilyId = document.getElementById('search-by-family-id');
const menuSearchByPlateId = document.getElementById('search-by-plate-id');
const menuSearchNameCount = document.getElementById('search-name-count');
const menuSearchSurnameCount = document.getElementById('search-surname-count');
const menuSearchTop100Names = document.getElementById('search-top-100-names');
const menuSearchTop100Surnames = document.getElementById(
  'search-surname-top-100',
);
const menuSearchByCellNumber = document.getElementById('search-by-cell-number');
const menuSearchBottom100names = document.getElementById(
  'search-bottom-100-names',
);
//Modal Elements:
const containerModal = document.querySelector('.container-modal');

document.addEventListener('keydown', function (e) {
  const modal = document.querySelector('.gjcmodal');
  if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
    closeModal();
  }
});

const listenForModalSubmit = function (apiCall) {
  const formBtn = document.querySelector('.gjc-modal-form-btn');
  const input1 = document.querySelector('.form__input--to');
  const input2 = document.querySelector('.form__input--amount');
  formBtn.addEventListener('click', function (e) {
    e.preventDefault();

    containerMovements.innerHTML = '';
    closeModal();

    const hamburgerMenu = document.querySelector('.hamburger-menu-box');
    hamburgerMenu.checked = false;

    const value1 = input1 ? input1.value.trim() : '';
    const value2 = input2 ? input2.value.trim() : '';

    apiCall(value1, value2);
  });
};

const queryGjcName = function (fname, lname) {
  queryByFirstLastName(fname, lname).then(jsonArray => {
    console.log('Name:', fname, lname);
    displayGjcData(jsonArray);
  });
};

const queryGjcId = function (nid) {
  queryGjcById(nid).then(jsonArray => {
    console.log('NID:', nid);
    displayGjcData(jsonArray);
  });
};

const queryGjcFamilyId = function (nid) {
  queryGjcByFamilyId(nid).then(jsonArray => {
    console.log('NID:', nid);
    displayGjcData(jsonArray);
  });
};

const queryGjcBottom100Names = function (year) {
  queryBottom100Names(year).then(jsonArray => {
    console.log('Year:', year);
    displaySimpleDataCard(jsonArray);
  });
};

const queryGjcByPlateId = function (plateId) {
  queryByPlateId(plateId).then(jsonArray => {
    console.log('PlateId:', plateId);
    displaySimpleDataCard(jsonArray);
  });
};

const queryGjcNameCount = function (name) {
  queryNameCount(name).then(jsonArray => {
    console.log('Name:', name);
    displaySimpleDataCard(jsonArray);
  });
};

const queryGjcSurnameCount = function (surname) {
  querySurameCount(surname).then(jsonArray => {
    console.log('surname:', surname);
    displaySimpleDataCard(jsonArray);
  });
};

const queryGjcTop100Names = function (year) {
  queryTop100NamesByYear(year).then(jsonArray => {
    console.log('year:', year);
    jsonArray.sort((a, b) => a.SASIA - b.SASIA);
    displaySimpleDataCard(jsonArray);
  });
};
const queryGjcTop100Surnames = function () {
  queryTop100SurnamesEver().then(jsonArray => {
    jsonArray.sort((a, b) => a.SASIA - b.SASIA);
    displaySimpleDataCard(jsonArray);
  });
};

const queryGjcByCellNumber = function (cellNr) {
  queryByCellNr(cellNr).then(jsonArray => {
    console.log('cellNr:', cellNr);
    displaySimpleDataCard(jsonArray);
  });
};

menuSearchByName.addEventListener('click', function (e) {
  showModalSearchByName(containerModal); //name, last name input
  listenForModalSubmit(queryGjcName);
});

menuSearchById.addEventListener('click', function (e) {
  showModalSearchInputOne(containerModal, 'Search By Id', 'id'); //nid input
  listenForModalSubmit(queryGjcId);
});

menuSearchByFamilyId.addEventListener('click', function (e) {
  showModalSearchInputOne(containerModal, 'Search By FamilyId', 'familyid'); //family id input
  listenForModalSubmit(queryGjcFamilyId);
});

menuSearchBottom100names.addEventListener('click', function (e) {
  showModalSearchInputOne(containerModal, 'Search Bottom 100 names', 'year'); //year input
  listenForModalSubmit(queryGjcBottom100Names);
});

menuSearchByPlateId.addEventListener('click', function (e) {
  showModalSearchInputOne(containerModal, 'Search By PlateId', 'targa'); //plate id input
  listenForModalSubmit(queryGjcByPlateId);
});

menuSearchNameCount.addEventListener('click', function (e) {
  showModalSearchInputOne(containerModal, 'Count names', 'first name'); //name input
  listenForModalSubmit(queryGjcNameCount);
});

menuSearchSurnameCount.addEventListener('click', function (e) {
  showModalSearchInputOne(containerModal, 'Count Surnnames', 'last name'); //name input
  listenForModalSubmit(queryGjcSurnameCount);
});

menuSearchTop100Names.addEventListener('click', function (e) {
  showModalSearchInputOne(
    containerModal,
    'Search top 100 names by year',
    'year',
  ); //year input
  listenForModalSubmit(queryGjcTop100Names);
});

menuSearchTop100Surnames.addEventListener('click', function (e) {
  const hamburgerMenu = document.querySelector('.hamburger-menu-box');
  hamburgerMenu.checked = false;
  queryGjcTop100Surnames();
});

menuSearchByCellNumber.addEventListener('click', function (e) {
  showModalSearchInputOne(
    containerModal,
    'Search by cell number',
    'cell number',
  ); //cell number input
  listenForModalSubmit(queryGjcByCellNumber);
});

/////////////////////////////////////////////////
// Functions

const returnValidatedResponse = (jsonArray, error = 'No Data Found') => {
  const errorMessage = [{ Error: error }];
  const isArrayValid = jsonArray !== undefined && jsonArray.length > 0;
  const response = isArrayValid ? jsonArray : errorMessage;
  return response;
};

function displaySimpleDataCard(jsonArray) {
  containerMovements.innerHTML = '';
  const arrayToLoop = [];
  if (jsonArray instanceof Array) {
    arrayToLoop.push(...jsonArray);
  } else {
    arrayToLoop.push(jsonArray);
  }

  const validatedArray = returnValidatedResponse(arrayToLoop);
  validatedArray.forEach(function (gjcObject, i) {
    const objectNID = gjcObject.id;
    console.log('object id is', objectNID);
    const type = isOdd(i) ? 'deposit' : 'withdrawal';

    let body = [];
    for (const [key, value] of Object.entries(gjcObject)) {
      body.push(gjcDivCardElement(key, value));
    }

    const content = `
    ${gjcDivCardHeader('', `${gjcObject.EMRI}`, type)}
    ${body.join('')}
    `;
    const html = cardViewContainer(content);

    containerMovements.insertAdjacentHTML('afterbegin', html);
  });
}

function displayGjcData(jsonArray) {
  containerMovements.innerHTML = '';

  // Check for error response
  if (jsonArray && jsonArray.error) {
    console.error('Server Error:', jsonArray);
    containerMovements.innerHTML = `
      <div class="error-message">
        <h3>Error: ${jsonArray.message}</h3>
        ${jsonArray.details ? `<p>Details: ${jsonArray.details}</p>` : ''}
        ${
          jsonArray.type === 'DB_ERROR'
            ? '<p>Database connection error. Please try again later.</p>'
            : ''
        }
      </div>`;
    return;
  }

  const validatedArray = returnValidatedResponse(jsonArray);

  if (!validatedArray || !Array.isArray(validatedArray)) {
    console.error('Invalid data received:', validatedArray);
    containerMovements.innerHTML =
      '<div class="error-message">No data available or error occurred</div>';
    return;
  }

  validatedArray.forEach(function (gjcObject, i) {
    if (!gjcObject) return;

    const objectNID = gjcObject.id;
    const objectFamilyId = gjcObject.family_id;
    console.log('object id is', objectNID);
    const type = isOdd(i) ? 'deposit' : 'withdrawal';

    let body = [];
    for (const [key, value] of Object.entries(gjcObject)) {
      body.push(gjcDivCardElement(key, value));
    }

    const content = `
    ${gjcDivCardHeader('', `${gjcObject.name} ${gjcObject.surname}`, type)}
    ${body.join('')}
    `;
    const html = cardViewContainer(content);

    containerMovements.insertAdjacentHTML('afterbegin', html);

    const celElement = document.querySelector('.shouldQueryRrogat--cel');
    const rrogatElement = document.querySelector('.shouldQueryRrogat--rrogat');
    const plateElement = document.querySelector(
      '.shouldQueryRrogat--plateArray',
    );
    const familyIdElement = document.querySelector(
      '.shouldQueryRrogat--family_id',
    );

    // Only add event listeners if elements exist
    if (celElement) {
      celElement.addEventListener('click', function (e) {
        e.preventDefault();
        if (objectNID) {
          queryCelById(objectNID).then(jsonArray => {
            console.log('queryCelById Success');
            openRrogatModal(
              containerModal,
              returnValidatedResponse(jsonArray),
              'Cel number data:',
            );
          });
        }
      });
    }

    if (rrogatElement) {
      rrogatElement.addEventListener('click', function (e) {
        e.preventDefault();
        if (objectNID) {
          queryRrogatById(objectNID).then(jsonArray => {
            console.log('queryRrogatById Success');
            openRrogatModal(
              containerModal,
              returnValidatedResponse(jsonArray),
              'Compensation data:',
            );
          });
        }
      });
    }

    if (plateElement) {
      plateElement.addEventListener('click', function (e) {
        e.preventDefault();
        if (objectNID) {
          queryPlateById(objectNID).then(jsonArray => {
            console.log('queryPlateById Success');
            openRrogatModal(
              containerModal,
              returnValidatedResponse(jsonArray),
              'Vehicle data:',
            );
          });
        }
      });
    }

    if (familyIdElement) {
      familyIdElement.addEventListener('click', function (e) {
        e.preventDefault();
        if (objectFamilyId) {
          console.log('queryGjcByFamilyId CLICKED');
          queryGjcByFamilyId(objectFamilyId).then(jsonArray => {
            console.log('queryGjcByFamilyId Success');
            displayGjcData(returnValidatedResponse(jsonArray));
          });
        }
      });
    }
  });
}

const updateUi = function (jwtToken, username = '') {
  if (jwtToken) {
    menuToggle.hidden = false;
    // Display UI and message
    labelWelcome.textContent = `Welcome back, ${username}`;
    //Show containerApp after login.
    containerApp.style.opacity = 100;
    //Hide login form after login
    formLogin.style.opacity = 0;
    setCognitoJwtToken(jwtToken);
  } else {
    menuToggle.hidden = true;

    // Hide UI and message
    labelWelcome.textContent = '';

    //Hide containerApp after sign out.
    containerApp.style.opacity = 0;

    //Show login form after sign out.
    formLogin.style.opacity = 100;
    setCognitoJwtToken(null);
    storeJwtToken(null);
  }
};

//UpdateUi based on the existence of the jwt token
(async () => {
  const token = await getInitializedToken();
  updateUi(token);
})();

const signInCallback = () => {
  return {
    success: function (username) {
      console.log('signInCallback success!');
      const token = getCurrentToken();
      updateUi(token, username);
    },
    error: function (error) {
      showModalError(containerModal, `Sign in error: ${error}`);
      console.log('signInCallback error!');
      updateUi(null);
    },
  };
};

const signOutCallback = () => {
  return {
    success: function () {
      console.log('signOutCallback success!');
    },
    error: function (error) {
      showModalError(containerModal, `Sign out error: ${error}`);
      console.log('signOutCallback error!');
    },
  };
};

btnLogin.addEventListener('click', function (e) {
  // Prevent form from submitting
  e.preventDefault();

  const username = inputLoginUsername.value.trim();
  const password = inputLoginPassword.value.trim();

  // Clear input fields
  inputLoginUsername.value = inputLoginPassword.value = '';
  inputLoginPassword.blur();
  cognitoSignIn(username, password, signInCallback());
});

signOut.addEventListener('click', function (e) {
  e.preventDefault();

  updateUi(null);
  cognitoSignOut(signOutCallback());
});
